import { createFileRoute } from '@tanstack/react-router';
import { InvoiceEditorPage } from '@/features/finance';

/** A new invoice draft (the editor without a saved invoice). */
export const Route = createFileRoute('/_auth/o/$orgId/finance/invoices/new')({
  component: NewInvoiceRoute,
});

function NewInvoiceRoute() {
  const { orgId } = Route.useParams();
  return <InvoiceEditorPage orgId={orgId} />;
}
